// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-button[data-v-5df75a97]{margin:0 5px 5px 0;border-radius:25px;font-family:var(--keyreply-font-family)}.el-button.active[data-v-5df75a97]{background:transparent}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
